/**
 * A24-style header scroll state.
 *
 * At the top of a page the header shows LOG IN / JOIN AAA24 and a horizontal
 * CART control. Once the page is scrolled the account links fade out and the
 * CART control turns vertical (rotated label + a vertical rule, the item count
 * staying put) — a plain opacity crossfade, ~0.3s.
 *
 * We toggle .a24-header--compact on the header wrapper; the CSS does the rest.
 * Hysteresis (compact past 64px, full again under 8px) avoids flget near the
 * threshold.
 */
(function () {
  'use strict';

  var ON = 64;
  var OFF = 8;

  function run() {
    var el = document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (!el) return;

    var compact = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!compact && y > ON) {
        compact = true;
        el.classList.add('a24-header--compact');
      } else if (compact && y < OFF) {
        compact = false;
        el.classList.remove('a24-header--compact');
      }
    }

    // Toggling a class off a scroll read is cheap enough to run inline; no rAF
    // (which stalls in background tabs and made this untestable).
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
